<template>
  <div id="enrolmentForm">
    <div class="container">
      <div class="datatable-edit__header">
        <K2Row space-between="true">
          <h3>Withdrawal List</h3>
          <K2Button size="small" @onclick="modal = 'generateStudentLinkModal'"> Generate URL </K2Button>
        </K2Row>
      </div>

      <el-input v-model="filters[0].value" class="search-datatable mb-3" placeholder="Search" id="inputSearchClassName">
        <template slot="prepend">
          <i class="material-icons">search</i>
          <span>Search</span>
        </template>
      </el-input>

      <div class="datatable_group">
        <template>
          <el-tabs type="card" @tab-click="handleClick">
            <el-tab-pane label="Pending">
              <div class="pendingList"><h4>Pending</h4></div>
              <data-tables :filters="filters" :data="enrolListInt" :action-col="enrolActionCol">
                <el-table-column v-for="items in enrolList" :prop="items.prop" :label="items.label" :key="items.prop" sortable="custom"> </el-table-column>
              </data-tables>
            </el-tab-pane>
            <el-tab-pane label="Reviewing">
              <div class="reviewingList"><h4>Reviewing</h4></div>
              <data-tables :filters="filters" :data="reviewListInt" :action-col="reviewActionCol">
                <el-table-column v-for="items in reviewList" :prop="items.prop" :label="items.label" :key="items.prop" sortable="custom"> </el-table-column>
              </data-tables>
            </el-tab-pane>
            <el-tab-pane label="Approved">
              <div class="approvedList"><h4>Approved</h4></div>
              <data-tables :data="approvedListInt" :action-col="approvedActionCol" :filters="filters">
                <el-table-column v-for="items in approvedList" :prop="items.prop" :label="items.label" :key="items.prop" sortable="custom"> </el-table-column>
              </data-tables>
            </el-tab-pane>
            <el-tab-pane label="Verified">
              <div class="approvedList"><h4>Verified</h4></div>
              <data-tables :data="verifiedListInt" :action-col="verifiedActionCol" :filters="filters">
                <el-table-column v-for="items in verifiedList" :prop="items.prop" :label="items.label" :key="items.prop" sortable="custom"> </el-table-column>
              </data-tables>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
      <!--<div class="emptylist-info" v-else>-->
      <!--<div class="emptylist__img">-->
      <!--<img src="../../assets/table-loading.png"/>-->
      <!--</div>-->
      <!--</div>-->
      <WdfGenerateLinkModal :modal="modal" @handleModalClose="modal = ''" />
    </div>
  </div>
</template>

<script>
import DataSource from '../../data/datasource'
import { lang } from '../../locale'
import Cookies from 'js-cookie'
import WdfGenerateLinkModal from './component/WdfGenerateLinkModal'
import K2Row from '../../uiComponents/k2Row/k2Row'
import K2Button from '../../uiComponents/k2Button/k2Button'
import { constDateFormat, getFormatDate } from '@/helper/utily'

const columns = [
  { prop: 'ID', label: 'ID' },
  { prop: 'Full_Name', label: 'First Name' },
  { prop: 'Last_name', label: 'Last Name' },
  { prop: 'Index_No', label: 'Student No' },
  { prop: 'momentDate', label: 'Withdrawal Date' },
  { prop: 'MainReason', label: 'Main Reason' },
  { prop: 'Reason1', label: 'Reason1' },
  { prop: 'Reason2', label: 'Reason2' },
  { prop: 'Reason3', label: 'Reason3' },
]

const actionCol = {
  label: lang('More'),
  props: { align: 'center' },
  buttons: [
    {
      props: { type: 'primary', icon: 'el-hand-up' },
      // handler: row => { window.open('/ApplicationManagement?id=' + row.APF_ID, "_blank"); },
      handler: row => {
        // VUE.$router.push(`/WithdrawalManagement?id=${row.StudentID}`);
        VUE.$router.push({
          name: 'WithdrawalManagement',
          query: { id: row.ID },
        })
      },
      label: lang('View'),
    },
  ],
}

export default {
  name: 'WithdrawalStatusList',
  components: { K2Button, K2Row, WdfGenerateLinkModal },
  data() {
    return {
      listCount: '',
      enrolListInt: [],
      enrolList: columns,
      enrolActionCol: actionCol,

      reviewListInt: [],
      reviewList: columns,
      reviewActionCol: actionCol,

      rejectedListInt: [],
      rejectedList: columns,
      rejectedActionCol: actionCol,

      approvedListInt: [],
      approvedList: columns,
      approvedActionCol: actionCol,

      verifiedListInt: [],
      verifiedList: columns,
      verifiedActionCol: actionCol,

      draftListInt: [],
      draftList: columns,
      draftActionCol: actionCol,

      modal: '',

      filters: [
        {
          value: '',
          prop: ['Index_No', 'Full_Name'],
        },
      ],
    }
  },
  async mounted() {
    window.VUE = this
    await this.fetch()
  },
  methods: {
    lang,
    async fetch() {
      this.$vs.loading()
      this.reset()
      const resp = await DataSource.shared.getWithdrawalList()
      if (resp) {
        if (resp?.code === '2') {
          this.$notify.error({
            title: 'Data not found',
            message: 'Data not found!',
          })
        } else {
          this.listCount = resp?.length

          for (const m of resp) {
            m.momentDate = getFormatDate(m?.Date, constDateFormat.default)
            if (m.Status === 'Reviewing' || m.Status === 'Submitted') this.reviewListInt.push(m)
            else if (m.Status === 'Approved') this.approvedListInt.push(m)
            else if (m.Status === 'Rejected') this.rejectedListInt.push(m)
            else if (m.Status === 'Pending') this.enrolListInt.push(m)
            else if (m.Status === 'Draft') this.draftListInt.push(m)
            else if (m.Status === 'Verified') this.verifiedListInt.push(m)
          }
        }
      }
      this.$vs.loading.close()
    },
    reset() {
      this.reviewListInt = []
      this.approvedListInt = []
      this.rejectedListInt = []
      this.enrolListInt = []
      this.draftListInt = []
      this.verifiedListInt = []
    },
    async handleClick(tab, event) {
      console.log(tab, event)
      await this.fetch()
    },
  },
}
</script>

<style scoped>
.pendingList {
  background-color: rgb(144, 179, 243);
  width: 100%;
  border-radius: 5px;
  color: white;
}

.approvedList {
  background-color: rgb(17, 100, 0);
  width: 100%;
  border-radius: 5px;
  color: white;
}

.rejectedList {
  background-color: red;
  width: 100%;
  border-radius: 5px;
  color: white;
}

.el-table td {
  padding: 1px 0;
}
</style>
